import React from "react";
import { Spinner } from "reactstrap";
import "./Loader.scss";

interface ILoaderProps {
  showOverlay?: boolean;
}

const LoaderComponent = (props: ILoaderProps) => {
  return (
    <div className={props.showOverlay ? "overlay" : ""}>
      <Spinner color="primary" className="spinner" />
      {/* <img
        className="spinner"
        src={require("../../../assets/images/default-loader.gif")}
        alt="loading"
      /> */}
    </div>
  );
};

LoaderComponent.defaultProps = {
  showOverlay: true,
};

export default LoaderComponent;
